import CONSTANTS from 'utils/constants';
import _ from 'ckLodash';

function getBlockParent(path) {
    return (path.block === null ? path.blockLimit : path.block);
}

function isWhiteSpace(text) {
    return (new RegExp('^[' + CONSTANTS.CK_GUARD + CONSTANTS.WIX_GUARD + '\n\r\\s\ufeff]*$')).test(text);
}

function isBlockElement(tagName) {
    return !!CKEDITOR.dtd.$block[tagName];
}

function isListElement(tagName) {
    return !!(CKEDITOR.dtd.$list[tagName] || CKEDITOR.dtd.$listItem[tagName]);
}

function getFindGuardsRegex() {
    return new RegExp(CONSTANTS.WIX_GUARD + '|' + CONSTANTS.CK_GUARD, 'g');
}

function removeGuardsChars(str) {
    var regex = getFindGuardsRegex();
    return _.replace(str, regex, '');
}

function getEditorTextLength(editor) {
    //ignore our or ck's invisible temporary guards
    return removeGuardsChars(editor.editable().$.textContent).length;
}

function getPlainTextFromHtml(htmlString) {
    var tempElement = document.createElement('div');
    tempElement.innerHTML = htmlString;
    return tempElement.textContent;
}

function getCKDocumentFragment(htmlStr) {
    var tmpDivElem = document.createElement('div');
    tmpDivElem.innerHTML = htmlStr;
    var fragment = document.createDocumentFragment();
    var nodesArray = Array.prototype.slice.call(tmpDivElem.childNodes);

    _.forEach(nodesArray, function (node) {
        fragment.appendChild(node);
    });
    return new CKEDITOR.dom.documentFragment(fragment);
}

function removeSpaces(text) {
    return text.replace(/\s/g, '');
}

function isTextBlock(node) {
    if (!node || !node.getName) {
        return false;
    }
    return CONSTANTS.TEXT_BLOCKS.indexOf(node.getName()) !== -1;
}

function isSafari() {
    return CKEDITOR.env.safari;
}

function isFF() {
    return CKEDITOR.env.gecko;
}

function isIE() {
    return CKEDITOR.env.ie;
}


function isListStateOn(editor) {
    return editor.getCommand('numberedlist').state !== CKEDITOR.TRISTATE_OFF ||
        editor.getCommand('bulletedlist').state !== CKEDITOR.TRISTATE_OFF;
}

function isSpellCheckCorrectionOccurred(newText, oldText) {
    if (!oldText) {
        return false;
    }

    var newTextWordsArr = (newText || '').trim().toLowerCase().split(/\s+/);
    var oldTextWordsArr = (oldText || '').trim().toLowerCase().split(/\s+/);

    return !_.isEqual(newTextWordsArr, oldTextWordsArr);
}

function isValidFontWeight(fontWeight) {
    var validWeights = _.range(100, 1000, 100);
    return _.includes(validWeights, fontWeight);
}

export default {
    getBlockParent: getBlockParent,
    getCKDocumentFragment: getCKDocumentFragment,
    getEditorTextLength: getEditorTextLength,
    getFindGuardsRegex: getFindGuardsRegex,
    getPlainTextFromHtml: getPlainTextFromHtml,
    isBlockElement: isBlockElement,
    isFF: isFF,
    isIE: isIE,
    isListElement: isListElement,
    isListStateOn: isListStateOn,
    isTextBlock: isTextBlock,
    isWhiteSpace: isWhiteSpace,
    isSafari: isSafari,
    removeGuardsChars: removeGuardsChars,
    removeSpaces: removeSpaces,
    isSpellCheckCorrectionOccurred: isSpellCheckCorrectionOccurred,
    isValidFontWeight: isValidFontWeight
};
